import {
  detectLogoContentType,
  logoContentTypes,
  maximumLogoBytes,
  type UploadLogoRequest,
} from '@stm/contracts';

/** Same-origin address of a club's logo; the version makes a replaced logo a new address. */
export function logoAddress(organizationId: string, logoVersion: number): string {
  return `/api/v1/organizations/${organizationId}/logo?v=${String(logoVersion)}`;
}

/** Value for the file input's `accept` attribute. */
export const logoFileAccept = logoContentTypes.join(',');

export type LogoFileProblem = 'unsupportedType' | 'tooLarge';

export type LogoFileResult =
  { ok: true; request: UploadLogoRequest } | { ok: false; problem: LogoFileProblem };

function toBase64(bytes: Uint8Array): string {
  let binary = '';
  const chunkSize = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }
  return btoa(binary);
}

/**
 * Checks the chosen image before it is sent: the bytes (not the file name) must be PNG, JPEG or
 * WebP, and small enough for the club to store. The server repeats both checks.
 */
export function prepareLogoUpload(bytes: Uint8Array): LogoFileResult {
  const contentType = detectLogoContentType(bytes);
  if (contentType === null) return { ok: false, problem: 'unsupportedType' };
  if (bytes.length > maximumLogoBytes) return { ok: false, problem: 'tooLarge' };
  return { ok: true, request: { contentType, dataBase64: toBase64(bytes) } };
}
